import "./footerTeamCard.sass";

export default function FooterTeamCard({ data }) {

  return (
    <div className="team-card__footer">
      {data && data.map((elem, id) => (
        <a key={`${id} - ${elem.action}`} className="team-card_footer-button" href={elem.url} target="_top" rel="noreferrer" >{elem.label}</a>
      ))}
    </div>
  )
}